import { Injectable, Injector } from '@angular/core';
import { WorkOrderControllerService } from '@app/generated/service';
import { WorkOrderEquipment } from './work-order-equipment.model';
import { AbstractWorkOrderDataService } from '@app/work-order/abstract-work-order-data.service';
import { map } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderEquipmentService extends AbstractWorkOrderDataService<WorkOrderEquipment[]> {
  constructor(
    private workOrderControllerService: WorkOrderControllerService,
    injector: Injector,
  ) {
    super(injector, 'EQUIPMENT');
  }

  public load(): void {
    this.workOrderControllerService
      .getEquipment(this.workOrderId)
      .pipe(
        map((dtos) => {
          return dtos.map((dto) => WorkOrderEquipment.fromDto(dto));
        }),
      )
      .subscribe({
        next: (data) => this.setData(data),
        error: (error) => {
          console.warn(
            `[EQUIPMENT] Failed to load equipment for ${this.workOrderId}. Falling back to offline data.`,
            error,
          );
          void this.handleLoadFailure([], error);
        },
      });
  }

  public async download() {
    try {
      const dtos = await firstValueFrom(this.workOrderControllerService.getEquipment(this.workOrderId));
      const equipment = (dtos || []).map((dto) => WorkOrderEquipment.fromDto(dto));
      this.setData(equipment);
    } catch (error) {
      console.warn('[EQUIPMENT] Failed to load equipment for offline download. Saving current/empty snapshot.', error);
      const current = this.get();
      this.setData(Array.isArray(current) ? current : []);
    }

    await super.download();
  }
}
